var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeSkillCst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.375 2.34375C17.1562 3.125 17.1562 4.40625 16.375 5.1875L14.625 6.9375L11.0625 3.375L12.8125 1.625C13.5938 0.84375 14.875 0.84375 15.6562 1.625L16.375 2.34375ZM2.375 12.0625L10.3438 4.09375L13.9062 7.65625L5.9375 15.625C5.75 15.8125 5.46875 15.9688 5.1875 16.0625L1.9375 17C1.6875 17.0625 1.40625 17 1.21875 16.7812C1 16.5938 0.9375 16.3125 1 16.0625L1.9375 12.8125C2.03125 12.5312 2.1875 12.25 2.375 12.0625ZM8.78125 4.25L4.21875 8.8125L1.5 6.0625C0.90625 5.5 0.90625 4.53125 1.5 3.96875L3.9375 1.5C4.5 0.9375 5.46875 0.9375 6.03125 1.5L6.65625 2.125C6.65625 2.15625 6.65625 2.15625 6.625 2.15625L4.625 4.15625C4.4375 4.34375 4.4375 4.6875 4.625 4.875C4.8125 5.0625 5.15625 5.0625 5.34375 4.875L7.34375 2.875C7.34375 2.84375 7.34375 2.84375 7.375 2.84375L8.78125 4.25ZM15.1562 10.625C15.1562 10.625 15.1562 10.6562 15.125 10.6562L13.125 12.6562C12.9375 12.8438 12.9375 13.1875 13.125 13.375C13.3125 13.5625 13.6562 13.5625 13.8438 13.375L15.8438 11.375C15.8438 11.3438 15.8438 11.3438 15.875 11.3438L16.5 11.9688C17.0625 12.5312 17.0625 13.5 16.5 14.0625L14.0312 16.5C13.4688 17.0938 12.5 17.0938 11.9375 16.5L9.1875 13.7812L13.75 9.21875L15.1562 10.625Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeSkillCst);
export default __webpack_public_path__ + "static/media/type_skill_cst.5bfcac0ad6a302e9e9d465338000dd67.svg";
export { ForwardRef as ReactComponent };